import { c as _c } from "react/compiler-runtime";
import usePermissions from './use-permissions';
const useCanEditAgent = () => {
  const $ = _c(2);
  const {
    hasPermission
  } = usePermissions();
  let t0;
  if ($[0] !== hasPermission) {
    t0 = hasPermission("onboarding_configuration");
    $[0] = hasPermission;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const hasOnboardingConfigurationPermission = t0;
  return hasOnboardingConfigurationPermission;
};
export default useCanEditAgent;